import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import heTranslation from './locales/he/translation.json';
import frTranslation from './locales/fr/translation.json';
import enTranslation from './locales/en/translation.json';
import ruTranslation from './locales/ru/translation.json';

const resources = {
  he: {
    translation: heTranslation
  },
  fr: {
    translation: frTranslation
  },
  en: {
    translation: enTranslation
  },
  ru: {
    translation: ruTranslation
  }
};

// Accept BOTH ?lang= and ?lng= in the URL. Our hreflang tags + ad/Google deep
// links use ?lang= while the built-in detector only read ?lng= — so RU campaign
// links silently opened in Hebrew. This custom detector reads either param.
const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'urlLang',
  lookup() {
    if (typeof window === 'undefined') return undefined;
    const p = new URLSearchParams(window.location.search);
    const v = (p.get('lang') || p.get('lng') || '').toLowerCase().slice(0, 2);
    return ['he', 'fr', 'en', 'ru'].includes(v) ? v : undefined;
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'he',
    supportedLngs: ['he', 'fr', 'en', 'ru'],
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['urlLang', 'querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage']
    }
  });

export default i18n;

// Helper function to get text direction based on language
export const getDirection = (language: string): 'rtl' | 'ltr' => {
  return language === 'he' ? 'rtl' : 'ltr';
};

// Language configurations
export const languages = [
  { code: 'he', name: 'עברית', flag: '🇮🇱', dir: 'rtl' as const },
  { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' as const },
  { code: 'en', name: 'English', flag: '🇺🇸', dir: 'ltr' as const },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', dir: 'ltr' as const }
];
